(function () {
  function initBpSliders(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-bp-slider]').forEach(function (slider) {
      if (slider.dataset.bpReady === '1') return;
      var track = slider.querySelector('.bp-slider-track');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.querySelectorAll('.bp-slide'));
      var n = slides.length;
      var dotsC = slider.querySelector('.bp-slider-dots');
      var thumbsC = slider.querySelector('[data-bp-thumbs]');
      var curEl = slider.querySelector('[data-bp-cur]');
      var totEl = slider.querySelector('[data-bp-total]');
      var prev = slider.querySelector('[data-bp-prev]');
      var next = slider.querySelector('[data-bp-next]');
      var cur = Number(slider.dataset.bpIndex || 0);
      if (cur > n - 1) cur = 0;

      if (totEl) totEl.textContent = String(n);
      slider.classList.toggle('is-single', n <= 1);

      if (dotsC) {
        dotsC.innerHTML = '';
        slides.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'bp-slider-dot' + (i === cur ? ' is-on' : '');
          b.setAttribute('aria-label', 'Image ' + (i + 1));
          b.onclick = function () { goTo(i); };
          dotsC.appendChild(b);
        });
      }

      if (thumbsC) {
        thumbsC.innerHTML = '';
        slides.forEach(function (slide, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'bp-thumb' + (i === cur ? ' is-on' : '');
          var img = slide.querySelector('img');
          var ph = slide.querySelector('.bp-ph');
          if (img) {
            var t = document.createElement('img');
            t.src = img.currentSrc || img.src;
            t.alt = '';
            t.loading = 'lazy';
            btn.appendChild(t);
          } else if (ph) {
            var p = document.createElement('div');
            p.className = 'bp-ph';
            p.dataset.label = ph.dataset.label || '';
            btn.appendChild(p);
          }
          btn.onclick = function () { goTo(i); };
          thumbsC.appendChild(btn);
        });
      }

      function render() {
        track.style.transform = 'translateX(-' + cur * 100 + '%)';
        slider.dataset.bpIndex = String(cur);
        if (curEl) curEl.textContent = String(cur + 1);
        if (dotsC) {
          dotsC.querySelectorAll('.bp-slider-dot').forEach(function (d, i) {
            d.classList.toggle('is-on', i === cur);
          });
        }
        if (thumbsC) {
          thumbsC.querySelectorAll('.bp-thumb').forEach(function (d, i) {
            d.classList.toggle('is-on', i === cur);
          });
        }
        if (prev) prev.disabled = n <= 1 || cur === 0;
        if (next) next.disabled = n <= 1 || cur >= n - 1;
      }

      function goTo(i) {
        if (!n) return;
        cur = Math.max(0, Math.min(n - 1, i));
        render();
      }

      if (prev) prev.onclick = function () { goTo(cur - 1); };
      if (next) next.onclick = function () { goTo(cur + 1); };

      if (!slider.dataset.bpSwipe) {
        slider.dataset.bpSwipe = '1';
        var x0 = null;
        var vp = slider.querySelector('.bp-slider-viewport');
        if (vp) {
          vp.addEventListener('pointerdown', function (e) { x0 = e.clientX; }, { passive: true });
          vp.addEventListener('pointerup', function (e) {
            if (x0 == null) return;
            var dx = e.clientX - x0;
            x0 = null;
            if (Math.abs(dx) > 48) goTo(cur + (dx < 0 ? 1 : -1));
          });
        }
      }

      slider.dataset.bpReady = '1';
      render();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBpSliders(document);
  });
  document.addEventListener('shopify:section:load', function (e) {
    initBpSliders(e.target);
  });
})();
